import { BasePage } from '@/components/ui/base-page'

export function OpportunityZonesPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add OpportunityZonesPage specific content here */}
    </BasePage>
  )
}